// // Select all elements with the class 'js-value'
// let nodeList = document.querySelectorAll('.js-value, .cart-item__variant-value, .filter-group__item__textm, .filter-group__item');



// // Iterate over the NodeList and replace text between parentheses
// nodeList.forEach(node => {
//     let text = node.textContent;
//     let matches = text.match(/\(([^)]+)\)(.*)/);;
//     if (matches) {
//         let value = matches[1] + matches[2];
//         node.textContent = value; // Replace the text content with the extracted value
//     }
// });

// maattabel
document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".logo-blc")) {
        document.querySelectorAll(".maattabel-blc").forEach(el => el.style.display = "block");
    } else {
        document.querySelectorAll(".maattabel-blc").forEach(el => el.style.display = "none");
    }

    if (document.querySelector(".logo-bl")) {
        document.querySelectorAll(".maattabel-bl").forEach(el => el.style.display = "block");
    } else {
        document.querySelectorAll(".maattabel-bl").forEach(el => el.style.display = "none");
    }
});


 // Function to process nodes and replace text
function processNodes(nodeList) {
    nodeList.forEach(node => {
        let text = node.textContent;
        let matches = text.match(/\(([^)]+)\)(.*)/);
        if (matches) {
            let value = matches[1] + matches[2];
            node.textContent = value; // Replace the text content with the extracted value
        }
    });
}

// List of classes to watch for
const targetClasses = ['js-value', 'cart-item__variant-value', 'filter-group__item__textm', 'filter-group__item'];

// Initial processing of existing nodes
targetClasses.forEach(cls => {
    let initialNodeList = document.querySelectorAll(`.${cls}`);
    processNodes(initialNodeList);
});

// MutationObserver to watch for new nodes
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
                targetClasses.forEach(cls => {
                    if (node.classList.contains(cls)) {
                        processNodes([node]);
                    } else {
                        // Check if new element contains any elements with the target classes
                        let newNodes = node.querySelectorAll(`.${cls}`);
                        processNodes(newNodes);
                    }
                });
            }
        });
    });
});

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });